<template>
  <div class="personnalPos-box">
    <div class="position-absolute p-10" id="history_path" :style="{ top: top }">
      <div class="path_header business_dialog_title c-white m-b-5">
        <span class="fz-14">人员定位-{{ currentState | filterName }}</span>
        <div class="fz-26">
          <i
            class="el-icon-caret-bottom"
            @click="changeDialogSize('isZoom')"
            v-if="currentState === 'isPutAway'"
          ></i>
          <i
            class="el-icon-caret-top"
            @click="changeDialogSize('isPutAway')"
            v-if="currentState === 'isZoom' || currentState === 'isOpenAll'"
          ></i>
          <i
            class="el-icon-caret-left"
            @click="changeDialogSize('isOpenAll')"
            v-if="currentState === 'isZoom'"
          ></i>
          <i
            class="el-icon-caret-right"
            @click="changeDialogSize('isZoom')"
            v-if="currentState === 'isOpenAll'"
          ></i>
          <i @click="closeComponent" class="cur_pointer iconfont icon-close r"></i>
        </div>
      </div>
      <!-- 人员列表 -->
      <div class="path_table" v-if="['isZoom', 'isOpenAll'].includes(currentState)">
        <el-table :data="personInfoList" class="w-100" height="100%" @cell-click="cellClick">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="username"
            label="用户"
            width="100"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="groupname"
            label="所属部门"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="job"
            v-if="['isOpenAll'].includes(currentState)"
            show-overflow-tooltip
            label="职位"
            width="80"
          ></el-table-column>
          <el-table-column prop="state" label="是否在厂" width="80"></el-table-column>
          <el-table-column
            prop="attendances"
            v-if="['isOpenAll'].includes(currentState)"
            show-overflow-tooltip
            label="所在区域"
            width="80"
          ></el-table-column>
        </el-table>
      </div>
      <div class="m-t-10 r" v-if="['isZoom', 'isOpenAll'].includes(currentState)">
        <el-button
          type="primary"
          :loading="historyBtnLoading"
          size="mini"
          @click="openHistoryPath"
          class="r"
          >历史轨迹</el-button
        >
      </div>
    </div>
    <!-- 人员历史轨迹框 -->
    <div class="historyRules-box fz-14" v-show="visibleHistoryPath">
      <div class="historyRules-inner" v-loading="historyPathLoading">
        <div class="historyRules-title">
          <span>历史轨迹</span>
          <i @click="cancelHistoryPath" class="iconfont icon-close r cur_pointer"></i>
        </div>
        <div class="historyRules-content p-l-20 p-r-20 m-t-20">
          <el-slider
            v-model="playProgress"
            @change="sliderChange"
            :min="0"
            :max="sliderMaxLenngth"
            :format-tooltip="formatSliderTooltip"
          ></el-slider>
          <div class="play-timeInfo" v-if="sliderBegin && sliderEnd">
            <span>{{ moment(sliderBegin).format('YYYY-MM-DD HH:mm:ss') }}</span>
            <span>{{ moment(sliderEnd).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </div>
          <div class="m-t-10 m-b-10 player-tool fz-12">
            <i class="el-icon-arrow-left fz-24" @click="minusSpeed"></i>
            <i
              class="fz-24"
              :class="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'"
              @click="playHistory"
            ></i>
            <i class="el-icon-arrow-right fz-24" @click="addSpeed"></i>
            <span class="speed-text-width">{{ speedList[currentSpeed] }}X速度</span>
            <div
              class="m-l-10"
              @click="
                (e) => {
                  e.stopPropagation()
                }
              "
            >
              视角：
              <el-radio-group v-model="currentAngle" @change="changeFollow">
                <el-radio :label="1">全局视角</el-radio>
                <el-radio :label="2">个人视角</el-radio>
              </el-radio-group>
            </div>
            <el-select
              clearable
              class="m-l-10"
              v-model="searchTagId"
              placeholder="--请选择--"
              popper-class="document_select-popper"
              filterable
              size="mini"
              @keyup.enter.native="getHistoryPathInfo"
            >
              <el-option
                v-for="item in personInfoList"
                :key="item.id"
                :label="item.username"
                :value="item.tagid"
              ></el-option>
            </el-select>
            <el-date-picker
              class="timer m-l-5"
              type="datetimerange"
              size="mini"
              popper-class="document_select-popper"
              v-model="dateTimes"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
            ></el-date-picker>
            <el-button type="primary" class="m-l-5" size="mini" @click="getHistoryPathInfo"
              >查询</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 详细人员信息框 -->
    <div
      class="visiblePersonnalInfo-box fz-14 p-10"
      v-drag
      v-if="visiblePersonnalInfo"
      :style="{ left: isShowBasicCom ? '405px' : '35px' }"
    >
      <div class="visiblePersonnalInfo-title m-b-5">
        <span class="fz-14">详细人员信息</span>
        <i @click="closeDetailInfo" class="iconfont icon-close r cur_pointer"></i>
      </div>
      <div class="visiblePersonnalInfo-inner fz-12 p-10">
        <el-row class="p-b-5">
          <el-col :span="6" :offset="0">姓名:</el-col>
          <el-col :span="14" :offset="2">{{ detailInfo.username }}</el-col>
        </el-row>
        <el-row class="p-b-5">
          <el-col :span="6" :offset="0">部门:</el-col>
          <el-col :span="14" :offset="2">{{ detailInfo.groupname }}</el-col>
        </el-row>
        <el-row class="p-b-5">
          <el-col :span="6" :offset="0">岗位:</el-col>
          <el-col :span="14" :offset="2">{{ detailInfo.job }}</el-col>
        </el-row>
        <el-row class="p-b-5">
          <el-col :span="6" :offset="0">是否在厂:</el-col>
          <el-col :span="14" :offset="2">{{ detailInfo.state }}</el-col>
        </el-row>
        <el-row class="p-b-5">
          <el-col :span="6" :offset="0">所在区域:</el-col>
          <el-col :span="14" :offset="2">{{ detailInfo.attendances }}</el-col>
        </el-row>
      </div>
      <p class="r m-t-5">
        <el-button type="primary" size="mini" :loading="historyBtnLoading" @click="openHistoryPath"
          >历史轨迹</el-button
        >
      </p>
    </div>
  </div>
</template>
<script>
import LocalSense from '@/services/baoChang/localSense'

export default {
  props: {
    currentPlayerId: {
      type: String,
      default: '',
    },
    loadedModel: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      defalut: '',
    },
    top: {
      type: String,
      defalut: '',
    },
    isShowBasicCom: {
      type: Boolean,
      defalut: false,
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      playProgress: 0,
      input: '1212',
      isPlaying: false, // 当前轨迹是否播放
      currentAngle: 1, // 当前视角
      dateTimes: [moment().subtract(2, 'h'), moment()],
      visibleHistoryPath: false, // 历史轨迹弹框显示与否
      visiblePersonnalInfo: false, // 详细人员信息弹框显示与否
      personInfoList: [],
      detailInfo: {
        username: '',
        groupname: '',
        job: '',
        state: '',
        attendances: '',
      },
      // 当前弹框的状态 isPutAway: false;收起状态 isZoom: false;缩放状态 isOpenAll: false;全部
      currentState: 'isPutAway',
      realPosition: [], // 实时位置信息
      wsApi: null, // 第三方websocket连接
      currentTagInfo: {
        tagid: '',
        createtime: '',
      }, // 人员标签信息
      historyBtnLoading: false,
      sliderMaxLenngth: 0, // 历史轨迹slider最大值
      sliderBegin: 0, // 进度条开始值
      sliderEnd: 0, // 进度条结束值
      currentSpeed: 0, // 播放速度
      speedList: [1, 5, 10], // 播放速度集合
      historyPathLoading: false,
      lastCreateList: [], // 上一次创建后的目标集合，含指针集合
      tagInfoList: [], // 人物头顶标签集合
      currentDataList: [], // 实时定位数据
      searchTagId: '',
      positionTimer: null,
      historyPathData: [],
      historyPointer: null, // 历史回放对象
      historyTarget: null, // 历史回放目标
      dialogLeft: '35px', // 弹框距离左侧位置
    }
  },
  async created() {
    if (!this.$route.query.fenceWarning || this.loadedModel) {
      this.getRelationTags()
      this.resetTargetInfo()
    }
  },
  watch: {
    currentDataList: {
      handler(val, oldVal) {
        const tagIdNew = val.map((item) => {
          return item.id
        })
        const tagIdOld = oldVal.map((item) => {
          return item.id
        })
        // 差集（新相对旧），创建
        const createData = val.filter((item) => {
          return tagIdOld.indexOf(item.id) === -1
        })
        // 交集,更新
        const updateData = val.filter((item) => {
          return tagIdOld.indexOf(item.id) > -1
        })
        // 差集（旧相对新），删除
        const deleteData = this.lastCreateList.filter((item) => {
          return tagIdNew.indexOf(item.id) === -1
        })
        this.operPosViewerObj(updateData, createData, deleteData)
        console.log(updateData, createData, deleteData, this.tagInfoList, 22222222)
      },
      deep: true,
    },
    loadedModel(val) {
      if (this.$route.query.fenceWarning && this.$route.query.tagId && val) {
        this.$nextTick(async () => {
          this.getRelationTags()
          this.resetTargetInfo()
          this.searchTagId = this.$route.query.tagId
          const tagBaseInfo = await this.getPersonnelInfoByTagid(
            this.searchTagId,
            this.$route.query.warningType === 'real'
          )
          const tagExtendInfo = await this.getTagInfoById(this.searchTagId)
          this.detailInfo = { ...tagBaseInfo, ...tagExtendInfo }
          this.detailInfo.attendances = this.detailInfo.attendances
            ? _.map(this.detailInfo.attendances, 'attendanceName').join(',')
            : ''
          this.visiblePersonnalInfo = true
          this.dialogLeft = this.isShowBasicCom ? '405px' : '35px'
          if (this.$route.query.warningType === 'history') {
            this.dateTimes = [
              moment(_.toNumber(this.$route.query.timestamp)),
              moment(_.toNumber(this.$route.query.timestamp)).add(30, 'm'),
            ]
            this.$forceUpdate()
            this.openHistoryPath()
          }
        })
      }
    },
  },
  beforeDestroy() {
    this.stopPlayBack()
    this.initPositionData()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  filters: {
    filterName(val) {
      switch (val) {
        case 'isZoom':
          return '缩略'
        case 'isPutAway':
          return '收起'

        default:
          return '详情'
      }
    },
  },
  methods: {
    // 关闭当前组件
    closeComponent() {
      this.$emit('closeComponent', 'PersonnalPosition')
    },
    // 切换视角
    async changeFollow(val) {
      const followNode = await this.player.Native.PosViewer.targetSkeletonNode(this.historyTarget)
      if (val === 1) {
        const followObject = await this.player.Native.TargetFollow.follow({
          followNode,
          followType: 1,
          targetPosOffset: [0, 0, 1.8],
        })
        this.player.Native.TargetFollow.setFollowThirdOffset(followObject, [0, 5, 2.3])
      } else {
        const followObject = await this.player.Native.TargetFollow.follow({
          followNode,
          followType: 2,
          targetPosOffset: [0, -0.6, 2.3],
        })
        this.player.Native.TargetFollow.setFollowFirstYawAngle(followObject, 90)
        this.player.Native.TargetFollow.setFollowFirstPitchAngle(followObject, 0)
      }
    },
    // 获取实时数据
    getCurrentRealData() {
      _.forEach(this.lastCreateList, (item) => {
        _.forEach(this.realPosition, (el) => {
          if (el.id === item.id) {
            el.pointer = item.pointer
          }
        })
      })
      this.currentDataList = this.realPosition
    },
    // 点击人物标签信息
    async clickTagMarker(e) {
      console.log(e)
      const markInfo = _.find(this.tagInfoList, ['markerId', e.markerId])
      if (markInfo) {
        this.visiblePersonnalInfo = true
        this.dialogLeft = this.isShowBasicCom ? '405px' : '35px'
        this.searchTagId = markInfo.tagId
        const tagBaseInfo = await this.getPersonnelInfoByTagid(markInfo.tagId, false)
        const tagExtendInfo = await this.getTagInfoById(markInfo.tagId)
        this.detailInfo = { ...tagBaseInfo, ...tagExtendInfo }
        this.detailInfo.attendances = this.detailInfo.attendances
          ? _.map(this.detailInfo.attendances, 'attendanceName').join(',')
          : ''
      }
    },
    // 加目标对象
    async operPosViewerObj(updateData, createData, deleteData) {
      // 创建
      _.forEach(createData, async (item) => {
        const pointer = await this.player.Native.PosViewer.addTarget(item.id)
        this.lastCreateList.push({
          ...item,
          pointer,
        })
        await this.player.Native.PosViewer.addTargetKeyPosition(
          pointer,
          // [item.x * 0.01, item.y * 0.01, item.z * 0.01], // 真实数据
          [item.x * 0.01 + 230, item.y * 0.01 + 130, -0.3], // 测试数据（基于河源全长模型做偏移）

          moment(item.timestamp).unix()
        )
        const createTag = await this.drawTagInfo(item.name)
        // eslint-disable-next-line no-await-in-loop
        const skeletonNode = await this.player.Native.PosViewer.targetSkeletonNode(pointer)
        if (skeletonNode && skeletonNode !== 0) {
          // eslint-disable-next-line no-await-in-loop
          const boneRoot = await this.player.Native.SkeletonNode.boneRoot(skeletonNode)
          if (boneRoot && boneRoot !== 0) {
            // eslint-disable-next-line no-await-in-loop
            const headBone = await this.player.Native.NodeProxy.findFirstNodeByName(
              boneRoot,
              'Bip001 HeadNub'
            )
            if (headBone && headBone !== 0) {
              this.player.Native.NodeProxy.setNodeParent(createTag, headBone)
              this.player.Native.NodeProxy.setLocalTranslation(createTag, [0, 0, 0])
            }
          }
        }
        this.tagInfoList.push({ tagId: item.id, markerId: createTag })
      })
      // 更新
      await this.player.Native.PosViewer.addTargetsKeyPosition(
        _.map(updateData, (upDateRes) => {
          return {
            target: upDateRes.pointer,
            // position: [upDateRes.x * 0.01, upDateRes.y * 0.01, upDateRes.z * 0.01],//真实数据
            // 测试数据（基于河源全长模型做偏移）
            position: [upDateRes.x * 0.01 + 230, upDateRes.y * 0.01 + 130, -0.3],
            time: moment(upDateRes.timestamp).unix(),
          }
        })
      )
      // 删除
      _.forEach(deleteData, async (item) => {
        const index = _.indexOf(
          _.map(this.lastCreateList, (val) => {
            return val.id
          }),
          item.id
        )
        const removeMarkerInfo = _.find(this.tagInfoList, ['tagId', item.id])
        if (removeMarkerInfo) {
          // 目标移除子节点
          this.player.Native.PosViewer.targetRemoveChildNode(
            item.pointer,
            removeMarkerInfo.markerId
          )
          // 销毁标签
          this.player.Native.GisMarker.destroy(removeMarkerInfo.markerId)
          _.remove(this.tagInfoList, ['tagId', item.id])
        }
        this.lastCreateList.splice(index, 1)
      })
      if (!_.isEmpty(deleteData)) {
        // 批量移除目标对象
        this.player.Native.PosViewer.removeTargets(
          _.map(deleteData, (removeRes) => {
            return removeRes.pointer
          })
        )
      }
    },
    // 历史轨迹回放
    async setHistoryPathPlay(id, name) {
      this.historyPointer = await this.player.Native.PosViewer.targetPlayBack()
      this.historyTarget = await this.player.Native.PosViewer.addTarget(id)
      await this.player.Native.PosViewer.addTargetKeyPosition(
        this.historyTarget,
        [this.historyPathData[0].x, this.historyPathData[0].y, this.historyPathData[0].z],
        moment(this.historyPathData[0].timestamp).unix()
      )
      const createTag = await this.drawTagInfo(name)
      // 获取目标人物模型的原始尺寸
      const targetSize = await this.player.Native.PosViewer.targetSkeletonModelSize(
        this.historyTarget
      )
      // 设置信息标签上移至人物头顶
      this.player.Native.NodeProxy.setLocalTranslation(createTag, [0, 0, targetSize[2]])
      // 目标添加子节点(信息标签)
      this.player.Native.PosViewer.targetAddChildNode(this.historyTarget, createTag)
      this.tagInfoList.push({ tagId: id, markerId: createTag })
      await this.player.Native.PosViewer.setPlayBackTarget(this.historyPointer, this.historyTarget)
      await this.player.Native.PosViewer.setPlayBackKeyFramesBegin(this.historyPointer)
      if (this.historyPathData.length > 1000) {
        const loopNum = Math.ceil(this.historyPathData.length / 1000)
        for (let i = 0; i < loopNum; i++) {
          const items = this.historyPathData.slice(i * 1000, (i + 1) * 1000)
          // eslint-disable-next-line no-await-in-loop
          await this.player.Native.PosViewer.setPlayBackKeyFrames(
            this.historyPointer,
            // eslint-disable-next-line no-loop-func
            _.map(items, (item) => {
              return {
                position: [item.x, item.y, item.z],
                time: moment(item.timestamp).unix(),
              }
            })
          )
          if (items.length < 1000) {
            this.player.Native.PosViewer.setPlayBackKeyFramesEnd(this.historyPointer)
          }
        }
      } else {
        await this.player.Native.PosViewer.setPlayBackKeyFrames(
          this.historyPointer,
          _.map(this.historyPathData, (item) => {
            return {
              position: [item.x, item.y, item.z],
              time: moment(item.timestamp).unix(),
            }
          })
        )
        this.player.Native.PosViewer.setPlayBackKeyFramesEnd(this.historyPointer)
      }
      this.changeFollow(1)
      const startTime = await this.player.Native.PosViewer.playBackStartTime(this.historyPointer)
      const endTime = await this.player.Native.PosViewer.playBackEndTime(this.historyPointer)
      this.sliderMaxLenngth = endTime - startTime
      this.player.Native.PosViewer.EventPlayBack.connect(this.watchPlayBack)
    },
    // 绘制标签
    async drawTagInfo(text) {
      const imgId = await PlayerUtils.call(
        this.player.Native.GisMarker.loadImage,
        `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/tag_info.png`
      )
      const option = {
        pos: [0, 0, 0], // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [250, 90], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [-50, -40], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [100, 40], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text, // 文本
        fontSize: 18.0, // 字体大小
        breakWidth: 100, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        contentPadding: [5, 5, 5, 5], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      // option里面的类容均为可选，但是option至少是{}，不能为null
      return await this.player.Native.GisMarker.create(option)
    },
    // 获取实时数据
    getRealPosition() {
      this.wsApi = window.LOCALSENSE.WEBSOCKET_API
      const userName =
        currentEnv.VUE_APP_SENSE_SERVER && currentEnv.VUE_APP_SENSE_SERVER.username
          ? currentEnv.VUE_APP_SENSE_SERVER.username
          : ''
      const password =
        currentEnv.VUE_APP_SENSE_SERVER && currentEnv.VUE_APP_SENSE_SERVER.password
          ? currentEnv.VUE_APP_SENSE_SERVER.password
          : ''
      const saltEnValue =
        currentEnv.VUE_APP_SENSE_SERVER && currentEnv.VUE_APP_SENSE_SERVER.salt
          ? currentEnv.VUE_APP_SENSE_SERVER.salt
          : ''
      this.closeWebsocket()
      this.wsApi.SetAccount(userName, password, mySaltEncryption(saltEnValue))
      this.wsApi.ClearBuffer()
      this.wsApi.onRecvTagPos = (obj) => {
        this.realPosition = []
        _.forIn(obj, (value, key) => {
          const tagInfo = _.find(this.personInfoList, ['tagid', key])
          if (tagInfo) {
            this.realPosition.push({ ...value, name: tagInfo.username, pointer: 0 })
          }
        })
      }
      // ws错误
      this.wsApi.onError = (obj) => {
        console.log(obj)
      }
      this.wsApi.onOpen = (obj) => {
        console.log(obj)
      }
      this.wsApi.onClose = (obj) => {
        console.log(obj)
      }
      const websocketUrl =
        currentEnv.VUE_APP_SENSE_SERVER && currentEnv.VUE_APP_SENSE_SERVER.websocketurl
          ? currentEnv.VUE_APP_SENSE_SERVER.websocketurl
          : '111.202.125.50:29001'
      this.wsApi.RequireBasicInfo(websocketUrl)
      this.wsApi.RequireExtraInfo(websocketUrl)
      this.wsApi.RequireControlInfo(websocketUrl)
      this.wsApi.setTag64CheckedFlag(false)
    },
    // 断开请求
    closeWebsocket() {
      this.wsApi.RejectBasicInfo()
      this.wsApi.RejectExtraInfo()
      this.wsApi.RejectControlInfo()
    },
    // 根据tagid获取详细信息
    async getPersonnelInfoByTagid(tagid, isMove) {
      const res = await LocalSense.getPersonnelPositionList(tagid)
      if (res && res.code === 0 && res.data && res.data.rows) {
        if (res.data.rows.x && res.data.rows.y && isMove) {
          if (this.$route.query.fenceWarning) {
            this.moveCameraToPos([res.data.rows.x, res.data.rows.y, 2])
          } else {
            this.moveCamera(tagid)
          }
        }
        return res.data.rows
      }
      return {}
    },
    // 根据tagid获取详细信息
    async getTagInfoById(tagid) {
      const res = await LocalSense.getPersonnelPositionInfo({ tagid })
      if (res && res.code === 0 && res.data && res.data.rows) {
        return res.data.rows
      }
      return {}
    },
    // 改变当前窗口
    changeDialogSize(name) {
      if (this.visibleHistoryPath) {
        return
      }
      this.currentState = name
    },
    // 查询权限内目标集合
    async getRelationTags() {
      const res = await LocalSense.getRelationTags()
      if (res && res.code === 0 && res.data && res.data.rows) {
        _.forEach(res.data.rows, async (item) => {
          const detailInfo = await this.getPersonnelInfoByTagid(item.tagid, false)
          const personInfo = {
            ...item,
            state: detailInfo.state,
            attendances: detailInfo.attendances
              ? _.map(detailInfo.attendances, 'attendanceName').join(',')
              : '',
          }
          this.personInfoList.push(personInfo)
        })
        console.log(this.personInfoList)
      }
    },
    // 点击列表项
    cellClick(val) {
      this.detailInfo = val
      this.visiblePersonnalInfo = true
      this.dialogLeft = this.isShowBasicCom ? '405px' : '35px'
      // if (this.visibleHistoryPath) {
      //   this.cancelHistoryPath()
      // }
      this.searchTagId = val.tagid
      this.getPersonnelInfoByTagid(val.tagid, _.isNil(this.historyPointer))
    },
    // 移动相机视角
    async moveCameraToPos(pos) {
      const modelInfo = await PlayerUtils.call(
        this.player.Native.Model.getInfo,
        this.currentPlayerId
      )
      /**
       * arr: 坐标点
       * modelInfo.nodePtr： 模型所在的坐标点
       */
      this.player.Native.Camera.moveToPos(pos, modelInfo.nodePtr, 5, 3)
    },
    // 移动相机视角
    async moveCamera(tagid) {
      const targetInfo = _.find(this.lastCreateList, (item) => {
        return _.toString(item.id) === tagid
      })
      if (targetInfo) {
        const followNode = await this.player.Native.PosViewer.targetSkeletonNode(targetInfo.pointer)
        const followObject = await this.player.Native.TargetFollow.follow({
          followNode,
          followType: 1,
          targetPosOffset: [0, 0, 1.8],
        })
        this.player.Native.TargetFollow.setFollowThirdOffset(followObject, [0, 5, 2.3])
        setTimeout(() => {
          this.player.Native.TargetFollow.unfollow()
        }, 2000)
      }
    },
    // 打开历史轨迹
    openHistoryPath() {
      this.currentState = this.$options.data().currentState
      if (this.searchTagId) {
        this.getHistoryPathInfo()
      }
      this.visibleHistoryPath = true
    },
    // 初始化定位信息
    initPositionData() {
      clearInterval(this.positionTimer)
      this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.clickTagMarker)
      this.player.Native.PosViewer.clearTargets()
      if (this.wsApi) {
        this.closeWebsocket()
      }
      _.forEach(this.tagInfoList, (el) => {
        this.player.Native.GisMarker.destroy(el.markerId)
      })
      this.lastCreateList = []
      this.tagInfoList = []
      this.realPosition = []
      this.currentDataList = []
    },
    // 创建定位标签信息
    resetTargetInfo() {
      this.getRealPosition()
      // const poolSize = this.player.Native.PosViewer.skeletonNodeObjectPoolSize()
      // if (poolSize < 100) {
      //   this.player.Native.PosViewer.skeletonNodeObjectPoolSize(100)
      // }
      this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.clickTagMarker)
      this.positionTimer = setInterval(() => {
        this.getCurrentRealData()
      }, 4000)
    },
    // 获取历史轨迹信息
    async getHistoryPathInfo() {
      this.stopPlayBack()
      this.initPositionData()
      this.historyBtnLoading = true
      this.historyPathLoading = true
      this.visiblePersonnalInfo = false
      const tagInfo = await this.getTagInfoById(this.searchTagId)
      const res = await LocalSense.getPersonnelHistoryPath({
        from:
          this.dateTimes && this.dateTimes[0]
            ? this.dateTimes[0].valueOf()
            : moment()
                .subtract(2, 'h')
                .valueOf(),
        to: this.dateTimes && this.dateTimes[1] ? this.dateTimes[1].valueOf() : moment().valueOf(),
        tagIdMsg: `${tagInfo.tagid || 0},${tagInfo.createtime || 0},0`,
        isSearchVideo: 0,
      })
      // const res = await $.ajax('/static/test.json')
      this.historyPathLoading = false
      this.historyBtnLoading = false
      console.log(res)
      if (res && res.code === 0 && res.data && res.data.listRows && res.data.rows) {
        this.sliderBegin = res.data.listRows[0] ? res.data.listRows[0].timeStepAppear : 0
        this.sliderEnd = res.data.listRows[0] ? res.data.listRows[0].timeStepDisppear : 0
        let mapData = []
        if (res.data.rows[0]) {
          mapData = _.map(res.data.rows[0], (item) => {
            return {
              name: item.objname,
              timestamp: item.timestamp,
              id: item.tagid,
              x: item.x,
              y: item.y,
              z: item.z,
            }
          })
        }
        this.historyPathData = mapData
        this.setHistoryPathPlay(tagInfo.tagid, tagInfo.username)
      } else {
        this.$message.warning(res.message)
      }
    },
    // 减速播放
    minusSpeed() {
      if (!this.historyPointer) {
        return
      }
      this.currentSpeed -= 1
      if (this.currentSpeed < 0) {
        this.currentSpeed = 0
      }
      this.player.Native.PosViewer.setPlayBackSpeed(
        this.historyPointer,
        this.speedList[this.currentSpeed]
      )
    },
    // 加速播放
    addSpeed() {
      if (!this.historyPointer) {
        return
      }
      this.currentSpeed = this.currentSpeed + 1
      if (this.currentSpeed > 2) {
        this.currentSpeed = 2
      }
      this.player.Native.PosViewer.setPlayBackSpeed(
        this.historyPointer,
        this.speedList[this.currentSpeed]
      )
    },
    // 滑动进度条
    sliderChange(val) {
      if (!this.historyPointer) {
        return
      }
      this.player.Native.PosViewer.playBackPause(this.historyPointer)
      this.player.Native.PosViewer.setPlayBackCurrentTime(this.historyPointer, val)
      this.isPlaying = false
      this.playProgress = val
    },
    // 播放历史轨迹
    async playHistory() {
      if (!this.historyPointer) {
        return
      }
      if (!this.isPlaying) {
        this.isPlaying = true
        const isPause = await this.player.Native.PosViewer.isPlayBackPause(this.historyPointer)
        if (isPause) {
          this.player.Native.PosViewer.playBackContinue(this.historyPointer)
        } else {
          this.player.Native.PosViewer.playBackStart(this.historyPointer)
        }
      } else {
        this.isPlaying = false
        this.player.Native.PosViewer.playBackPause(this.historyPointer)
      }
    },
    // 历史轨迹播放通知
    watchPlayBack(info) {
      this.playProgress = _.floor(info.currentTime)
      if (info.state === 2 || info.state === 5) {
        this.isPlaying = false
      }
    },
    // 停止播放历史轨迹
    stopPlayBack() {
      if (this.historyPointer) {
        this.player.Native.PosViewer.setPlayBackSpeed(this.historyPointer, 1)
        this.player.Native.PosViewer.EventPlayBack.disconnect(this.watchPlayBack)
        this.player.Native.PosViewer.playBackStop(this.historyPointer)
        this.player.Native.PosViewer.clearPlayBack(this.historyPointer)
        this.historyPointer = null
        this.historyTarget = null
        this.currentSpeed = 0
        this.isPlaying = false
        this.playProgress = 0
      }
    },
    // 格式化进度条提示词
    formatSliderTooltip(val) {
      return this.sliderBegin
        ? moment((moment(this.sliderBegin).unix() + val) * 1000).format('HH:mm:ss')
        : '00:00:00'
    },
    // 关闭详细信息
    closeDetailInfo() {
      this.visiblePersonnalInfo = false
      this.detailInfo = this.$options.data().detailInfo
      if (this.visibleHistoryPath) {
        this.cancelHistoryPath()
      }
      this.searchTagId = null
    },
    // 关闭历史轨迹
    cancelHistoryPath() {
      this.player.Native.TargetFollow.unfollow()
      this.dateTimes = this.$options.data().dateTimes
      this.stopPlayBack()
      this.visibleHistoryPath = false
      this.currentSpeed = 0
      this.isPlaying = false
      this.playProgress = 0
      this.currentAngle = 1
      this.initPositionData()
      this.resetTargetInfo()
      this.dateTimes = this.$options.data().dateTimes
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';
.personnalPos-box {
  i {
    cursor: pointer;
  }
  #history_path {
    padding: 0 10px;
    right: 35px;
    background-color: rgba(46, 107, 176, 0.5) !important;
    border-radius: 4px;
    z-index: 99;
    .path_header {
      min-width: 348px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .path_table {
      height: calc(60vh - 100px);
    }
  }
  /deep/ .el-table__body-wrapper {
    background-color: transparent !important;
  }
  .el-button + .el-button {
    margin-left: 0px;
  }
  /deep/.el-dialog {
    margin: 88vh auto 0 !important;
  }
  .historyRules-box {
    width: 100%;
    position: absolute;
    left: 0px;
    bottom: 90px;
    z-index: 100;
    color: rgb(247, 241, 241);
    /deep/ .el-loading-mask {
      background: #1a3955f0 !important;
    }
    .historyRules-inner {
      width: 50%;
      margin: auto;
      padding: 5px 10px;
      background: linear-gradient(#02457a, #1167b1) !important;

      .play-timeInfo {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
      /deep/.el-slider__button {
        width: 20px;
        height: 12px;
        border-radius: 10px;
      }
      /deep/ .el-date-editor .el-range-input {
        color: #ffffff;
        background-color: transparent;
      }
      /deep/ .el-range-editor--mini .el-range-separator {
        color: #ffffff;
      }
      .player-tool {
        display: flex;
        flex-direction: row;
        align-items: center;
        i {
          color: rgb(68, 167, 248);
        }
        /deep/ .el-radio__label {
          font-size: 12px;
        }
        /deep/.el-radio {
          color: rgb(247, 241, 241) !important;
        }
        .timer {
          width: 300px !important;
        }
        .speed-text-width {
          width: 60px;
        }
      }
      .historyRules-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .visiblePersonnalInfo-box {
    color: #fff;
    width: 260px;
    position: absolute;
    top: 66px;
    left: 35px;
    z-index: 100;
    border-radius: 4px;
    background-color: rgba(46, 107, 176, 0.5) !important;
    .visiblePersonnalInfo-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .visiblePersonnalInfo-inner {
      background-color: rgba(24, 41, 72, 0.5) !important;
    }
  }
}

</style>
